var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-toolbarBg"},[_c('div',[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"width-135",attrs:{"id":"content"}},[_c('ejs-dropdownlist',{attrs:{"id":"games","dataSource":_vm.data,"fields":_vm.fields,"popupHeight":"auto","placeholder":_vm.waterMark,"change":_vm.changeFunc}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }